import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '../lib/utils';
import { Button } from './ui/button';
import { Eye, MousePointerClick, FileText, Send, UserPlus, Loader2, Star } from 'lucide-react';

const authHeaders = () => {
  const t = localStorage.getItem('token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

const Stat = ({ icon: Icon, label, value }) => (
  <div className="flex flex-col items-center bg-white rounded-lg border p-2">
    <Icon className="w-4 h-4 text-primary" />
    <span className="text-lg font-bold text-gray-900 tabular-nums">{value}</span>
    <span className="text-[10px] text-gray-500">{label}</span>
  </div>
);

const FeaturedJobAnalytics = ({ job }) => {
  const [s, setS] = useState(null);
  const [inviting, setInviting] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API_URL}/jobs/${job.job_id}/invitations`, { headers: authHeaders() })
      .then((r) => setS(r.data)).catch(() => setS(null));
  }, [job.job_id]);
  useEffect(() => { load(); }, [load]);

  const invite = async () => {
    setInviting(true);
    try {
      const r = await axios.post(`${API_URL}/jobs/${job.job_id}/invite-candidates`, {}, { headers: authHeaders() });
      toast.success(r.data.message);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not send invitations'); } finally { setInviting(false); }
  };

  return (
    <div className="bg-secondary/5 border border-secondary/20 rounded-xl p-4" data-testid={`featured-analytics-${job.job_id}`}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-semibold text-primary flex items-center gap-1.5"><Star className="w-4 h-4 text-secondary fill-current" /> {job.title}</h4>
        {job.urgently_hiring && <span className="text-[10px] bg-red-600 text-white font-bold px-2 py-0.5 rounded-full">Urgently Hiring</span>}
      </div>
      {!s ? <div className="text-center py-3"><Loader2 className="w-4 h-4 animate-spin text-gray-400 mx-auto" /></div> : (
        <>
          <div className="grid grid-cols-4 gap-2 mb-3">
            <Stat icon={Eye} label="Views" value={s.views} />
            <Stat icon={MousePointerClick} label="Clicks" value={s.clicks} />
            <Stat icon={FileText} label="Applications" value={s.applications} />
            <Stat icon={Send} label="Invites sent" value={s.used} />
          </div>
          <div className="flex items-center justify-between text-xs text-gray-600">
            <span data-testid={`invites-remaining-${job.job_id}`}>{s.remaining} of {s.allowance} candidate invitations left · {s.responded} responded</span>
            <Button size="sm" onClick={invite} disabled={inviting || s.remaining <= 0} className="bg-primary text-white h-8" data-testid={`invite-candidates-${job.job_id}`}>
              {inviting ? <Loader2 className="w-3.5 h-3.5 animate-spin mr-1" /> : <UserPlus className="w-3.5 h-3.5 mr-1" />}
              Invite candidates
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default FeaturedJobAnalytics;
